import React, { useState } from "react";
import PropTypes from "prop-types";

// Bring in Redux
import { connect } from "react-redux";
// Functions
import {
  filterBenchmarks,
  getBaseYearCollection,
} from "../benchmarking-project-selection/BenchmarkSelectionFilter.functions";

import ModalBenchmarkingUploader from "./BenchmarkUploadModal";
import { useBenchmarking } from "../../api/benchmarking-control/BenchmarkingControlAPI";
import BenchmarkControlTable from "./BenchmarkControlTable";
import BenchmarkingTPICityControl from "../benchmarking-tpi-select/BenchmarkTPICityControl";
import ModalBenchmarkInfoFlag from "./BenchmarkInfoFlagModal";

import { DeleteBenchmark, ExportBenchmark } from "./Benchmark.components";

import "./Benchmark.css";
import BenchmarkSelectionFilter from "../benchmarking-project-selection/BenchmarkSelectionFilter";
import { getDecoratedData } from "./BenchmarkControlTable.functions";
import { useSensitivityLevelCodes } from "../../api/benchmarking/BenchmarkingAPI";
import ExportBenchmarkDashboard from "./ExportBenchmarkDashboard";
import isEmpty from "../../validation/is-empty";
import { BA_CBS_ROLE, BA_ROLE, hasRoles } from "../../utils/roles";
import { useConfigureSettings } from "../../api/dashboards/ConfigureAPI";
import BasicBenchmarkModal from "./BasicBenchmarkModal";

/// props validation | SQ(javascript:S6774)
Benchmark.propTypes = {
  auth: PropTypes.object,
};
///
function Benchmark(props) {
  // PROPS
  const { user } = props.auth;
  // Benchmark Data
  const { benchmarking, setBenchmarking } = useBenchmarking(user);

  const [benchmarkSelectionFilters, setBenchmarkSelectionFilters] = useState(
    {}
  );

  const filteredBenchmarks = filterBenchmarks(
    null, // no Project ID
    benchmarking,
    benchmarkSelectionFilters
  );

  // Benchmarks Selected by User
  const [selectedBenchmarks, setSelectedBenchmarks] = useState([]);
  const { sensitivityLevelCodes } = useSensitivityLevelCodes();
  const configureSettings = useConfigureSettings(
    user.id,
    "MASTER_BENCHMARKING"
  );

  if (
    isEmpty(sensitivityLevelCodes) ||
    configureSettings.configureSettings.loading
  )
    return null;
  let sortedBaseYear = getBaseYearCollection(benchmarking);
  // Data has loaded
  return (
    <div className="benchmarking-control-panel-container">
      <div className="benchmark-advanced-search-flex-backer">
        <div className="benchmark-advanced-search-flex">
          <div className="benchmark-input-container">
            <div className="benchmark-control-title">
              <h1 className="display-4" style={{ fontSize: "30px" }}>
                Benchmarking
              </h1>
            </div>
          </div>

          <div className="project-control-panel">
            {!isEmpty(filteredBenchmarks) && (
              <div className="benchmark-button-flex">
                <ModalBenchmarkingUploader setBenchmarking={setBenchmarking} />
                <BasicBenchmarkModal
                  setBenchmarking={setBenchmarking}
                  selectedBenchmarks={selectedBenchmarks}
                />

                <ModalBenchmarkInfoFlag
                  selectedBenchmarks={selectedBenchmarks}
                  setBenchmarking={setBenchmarking}
                />

                <BenchmarkingTPICityControl
                  selectedBenchmarks={selectedBenchmarks}
                  setBenchmarking={setBenchmarking}
                />

                {hasRoles(user.roles, BA_CBS_ROLE) && (
                  <ExportBenchmark selectedBenchmarks={selectedBenchmarks} />
                )}
                {hasRoles(user.roles, BA_ROLE) &&
                  !isEmpty(filteredBenchmarks) && (
                    <ExportBenchmarkDashboard
                      benchmarks={getDecoratedData(
                        filteredBenchmarks,
                        sensitivityLevelCodes
                      )}
                    />
                  )}
                <DeleteBenchmark
                  selectedBenchmarks={selectedBenchmarks}
                  setBenchmarking={setBenchmarking}
                  setSelectedBenchmarks={setSelectedBenchmarks}
                />
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="benchmark-table-column">
        <div className="benchmark-table-container">
          <div className="benchmark-table-flex">
            <BenchmarkSelectionFilter
              isPublishedDisabled={false}
              setFilters={setBenchmarkSelectionFilters}
              benchmarkingForBenchmark={[]}
              globalBenchmark={true}
              sortedBaseYear={sortedBaseYear}
              disableQuickBenchmarks={true}
            />
            <div className="benchmark-control-table">
              <BenchmarkControlTable
                data={filteredBenchmarks}
                setBenchmarking={setBenchmarking}
                selectedBenchmarks={selectedBenchmarks}
                setSelected={setSelectedBenchmarks}
                user={user}
                sensitivityLevelCodes={sensitivityLevelCodes}
                configureSettings={configureSettings}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default connect((state) => ({
  auth: state.auth,
}))(Benchmark);
